import {createSlice} from '@reduxjs/toolkit';

const initialState = {
    events: [],
    stats: {
        total_events: 0,
        total_transactions_in_rupiah: 0,
        total_transactions: 0,
        total_visitors: 0,
        transactions_rp_percent_date_to_date: 0,
        transactions_date_to_date: 0,
        visitors_date_to_date: 0,
    },
    transactions: [],
    visitors: [],
    loading: false,
    errorMsg: '',
    errors: {}
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        events: (state, action) => {
            state.events = action.payload;
        },
        visitors: (state, action) => {
            state.visitors = action.payload;
        },
        transactions: (state, action) => {
            state.transactions = action.payload;
        },
        stats: (state, action) => {
            state.stats = action.payload;
        },
        getErrors: (state, action) => {
            state.errorMsg = action.payload.errorMsg;
            state.errors = action.payload.errors;
        },
        clearErrors: (state) => {
            state.errorMsg = '';
            state.errors = '';
        },
        loading: (state, action) => {
            state.loading = action.payload;
        }
    },
});

export const { loading, events, visitors, transactions, stats, clearErrors, getErrors } = dashboardSlice.actions;
export default dashboardSlice.reducer;
